import React from 'react';
import CompanyForm from './CompanyForm';
import { connect } from 'react-redux';
import { companyActions } from 'redux/actions/company-action';
import {
  Grid,
  Row,
  Col
} from "react-bootstrap";
import { Card } from "components/Card/Card.jsx";
import BackNavigationButton from "components/ThemeComponents/BackNavigationButton";

class EditCompanyPage extends React.Component {
	constructor(props){
		super(props);

		const { id } = this.props.match.params;

		this.state = {
			companayId : id,
			contact :{},
			formType:'edit',
		};
		this.handleAction = this.handleAction.bind(this);
	};
	handleAction(companyData){

		this.props.editCompanyCall(this.state.companayId, companyData);
	};
	componentDidMount () {

	    this.props.getCompanyCall(this.state.companayId);
  	}

  	componentWillReceiveProps(nextProps) {
      if (nextProps.editCompany){
        this.setState({contact:nextProps.editCompany.contact}, function(){
        });
      }  
  	}
	render(){
		const { editCompany } = this.props;
		return(

			<div className="content">
	        	<Grid fluid>
	          		<Row>
	            		<Col md={12}>
	              			<Card
				                headerTopContent={
				                	<div style={{ marginBottom: "10px" }}>
				                		<BackNavigationButton
				                			defaultPath="Companies"
				                			queryPrefix=""
				                			className="btn btn-info btn-sm"
				                			title="Back"
				                		/>
				                	</div>
				                }
				                title="Edit Company"
				                content={
				                	<div>
			                            <Grid fluid>
			                                <Row>
			                                	<Col md={12}>
			                                		{
														editCompany && this.state.contact && <CompanyForm handleActionParent={this.handleAction}  companyDataFP={editCompany} companyContactDataFP = {this.state.contact} formType={this.state.formType} adminType="admin" />
													}
			                                	</Col>
			                                </Row>
			                            </Grid>
			                        </div>
				                }
				            />
	             		</Col>
	            	</Row>
	          	</Grid>
	        </div>
			
		);
	};
}

const mapDispatchToProps = dispatch => {
  return ({
    getCompanyCall  : (id) => { dispatch(companyActions.getCompany(id)) },
    editCompanyCall : (id,companyData) => { dispatch(companyActions.editCompany(id, companyData)) }
  });
};

function mapStateToProps(state) {
    const { loading, editCompany } = state.companyReducer;


    return {
        loading, editCompany
    };
}

const EditCompany = connect(mapStateToProps, mapDispatchToProps)(EditCompanyPage);
export default EditCompany;


// WEBPACK FOOTER //
// ./src/components/Admin/Company/EditCompany.jsx